/** Integracje → Dziennik synchronizacji z ERP i kolejka do ERP (klucze: erps.*). */
export const erpsPl = {
  nav: { group: 'Integracje', log: 'Dziennik synchronizacji', outbox: 'Kolejka do ERP' },
  page: {
    title: 'Dziennik synchronizacji',
    description: 'Ciągła synchronizacja z ERP (InsERT GT): źródła, harmonogram, przebiegi, uzgodnienie miesięcy.',
    source: 'Źródło',
    lastSuccess: 'Ostatnia udana',
    schedulerOn: 'Harmonogram aktywny',
    schedulerOff: 'Harmonogram wyłączony',
    alarm: 'Synchronizacja nie działa',
    schedulerOffHint: 'Harmonogram jest wyłączony na serwerze (ERP_SYNC_ENABLED). Ręczne uruchomienie i próba na sucho działają, jeśli serwer ma połączenie z bazą ERP.',
    tabs: { feeds: 'Źródła', runs: 'Przebiegi', changes: 'Dziennik zmian' },
    never: 'nigdy',
  },
  feed: {
    customers: 'Klienci',
    products: 'Towary',
    documents: 'Dokumenty',
    receivables: 'Należności',
    routimo: 'Trasy Routimo',
    reconcile: 'Uzgodnienie miesięcy',
    'ledger-costs': 'Koszty z księgi',
    collections: 'Windykacja',
    cashflow: 'Cash flow',
    purchasing: 'Zakupy i stany',
    quality: 'Jakość — przyjęcia PZ',
    commissions: 'Prowizje handlowców',
    consents: 'Zgody klientów',
    retro: 'Retro klientów',
    warehouse: 'Magazyn — WZ',
    prices: 'Cennik i ceny klienta',
    leave: 'Urlopy pracowników',
  },
  feedHint: {
    customers: 'Kontrahenci, adresy, osoby kontaktowe, opiekunowie',
    products: 'Grupy towarów i towary',
    documents: 'FV, KOR, PA, ZK, WZ w oknie kroczącym {days} dni',
    receivables: 'Otwarte należności i spłaty',
    routimo: 'Planowane przystanki tras (4:00–10:00)',
    reconcile: 'Liczba i netto dokumentów per miesiąc, 24 mies.; różniące się miesiące czytane ponownie',
    'ledger-costs': 'Rewizor: kadry wg działów, koszty pojazdów, produkcja — 3 ostatnie miesiące, co noc',
    collections: 'Wezwania do zapłaty, działania windykacyjne i e-monity (tylko nowe)',
    cashflow: 'Kasy, dokumenty kasowe i bankowe, wyciągi i zobowiązania (okno {days} dni)',
    purchasing: 'Dostawcy, FZ, KFZ, PZ, ZD w oknie kroczącym {days} dni i stany magazynowe',
    quality: 'Przyjęcia towaru (PZ) z 45 dni — dostawca towaru do analizy reklamacji (3:15)',
    commissions: 'Dodatek prowizyjny InsERT: handlowcy, stawki, wypłaty (raz na dobę)',
    consents: 'Zgoda na e-faktury, zgoda marketingowa i na e-mail (ankieta klienta)',
    retro: 'Retro z pola własnego „RETRO” klienta w Subiekcie (karta klienta, marża po retro — tylko zarząd)',
    warehouse: 'Dokumenty WZ do kompletacji (pozycje, ilość, czas utworzenia) z ostatnich dni',
    prices: 'Poziomy cen towarów, rabaty i grupy klientów, ceny indywidualne i promocje z dodatku (pełny odczyt co 20 h)',
    leave: 'Z Gratyfikanta: imię i nazwisko, wymiar i zaległy urlop, daty urlopów wypoczynkowych (bez L4 i innych nieobecności)',
  },
  card: {
    status: {
      running: 'W trakcie',
      alarm: 'ALARM',
      unavailable: 'Jeszcze niedostępne',
      off: 'Poza harmonogramem',
      failed: 'Ostatni przebieg z błędem',
      ok: 'Działa',
    },
    records: 'Śledzone rekordy',
    schedule: 'Harmonogram',
    every: 'co {minutes} min',
    daily: 'codziennie o {time}',
    hours: '{from}:00–{to}:00',
    lastSuccess: 'Ostatni sukces',
    lastRun: 'Ostatni przebieg',
    alarmText: 'Brak udanej synchronizacji od ponad {minutes} min.',
    failing: 'Awaria od {since}, nieudanych prób z rzędu: {count}.',
    lastError: 'Ostatni błąd: {error}',
    unavailableHint: 'Mapowanie tego źródła nie jest jeszcze wdrożone w tej wersji serwera.',
    dryRun: 'Próba na sucho',
    run: 'Uruchom teraz',
    confirmRun: 'Uruchomić synchronizację „{feed}” z ZAPISEM zmian w NEXOPS?',
    enabled: 'W harmonogramie',
    enable: 'Włącz w harmonogramie',
    disable: 'Wyłącz z harmonogramu',
  },
  toast: {
    done: '{feed}{dry}: nowe {created}, zmienione {changed}, zniknęły {removed}',
    dry: ' (na sucho)',
    running: '{feed}: przebieg trwa — śledź go na liście przebiegów',
    skipped: '{feed}: poprzedni przebieg jeszcze trwa — pominięto',
    failed: '{feed}: {error}',
    unavailable: 'To źródło nie jest jeszcze dostępne.',
    settingsSaved: 'Zapisano harmonogram źródeł',
  },
  runs: {
    title: 'Przebiegi',
    description: 'Każde uruchomienie źródła: harmonogram, ponowienie, ręczne i próby na sucho.',
    empty: 'Brak przebiegów',
    allFeeds: 'Wszystkie źródła',
    allStatuses: 'Wszystkie statusy',
    col: {
      started: 'Start',
      feed: 'Źródło',
      trigger: 'Wyzwalacz',
      status: 'Status',
      duration: 'Czas',
      fetched: 'Pobrano',
      created: 'Nowe',
      changed: 'Zmienione',
      unchanged: 'Bez zmian',
      removed: 'Zniknęły',
      restored: 'Wróciły',
      notes: 'Uwagi',
    },
    dryRun: 'na sucho',
  },
  status: { RUNNING: 'W trakcie', SUCCESS: 'Sukces', PARTIAL: 'Częściowo', FAILED: 'Błąd', SKIPPED: 'Pominięty' },
  trigger: { SCHEDULE: 'Harmonogram', MANUAL: 'Ręcznie', CLI: 'Konsola', STARTUP: 'Start serwera', RETRY: 'Ponowienie' },
  detail: {
    back: 'Dziennik synchronizacji',
    title: 'Przebieg: {feed}',
    window: 'Okno odczytu',
    by: 'Uruchomił',
    finished: 'Koniec',
    warnings: 'Ostrzeżenia',
    error: 'Błąd',
    report: 'Raport',
    noReport: 'Przebieg nie zapisał raportu.',
    notFound: 'Nie znaleziono przebiegu.',
    preview: 'Podgląd zmian (próba na sucho)',
    previewCounts: 'Nowe: {created} · zmienione: {changed} · wróciły: {restored} · zniknęły: {removed} · wypadły z okna: {agedOut}',
    rawReport: 'Pełny raport (JSON)',
  },
  reconcile: {
    title: 'Uzgodnienie z ERP',
    summary: 'Okres {from} – {to}: różnice w {different} mies., ponownie odczytane {reread}, nadal różne {still}.',
    col: { month: 'Miesiąc', type: 'Typ', erpCount: 'ERP — liczba', nexopsCount: 'NEXOPS — liczba', erpNet: 'ERP — netto', nexopsNet: 'NEXOPS — netto', state: 'Stan' },
    equal: 'Zgodne',
    fixed: 'Poprawione odczytem',
    differs: 'Różnica',
    onlyDiff: 'Tylko różnice',
    statuses: 'Liczone statusy dokumentów ERP: {statuses}',
    breakdown: 'ERP według typu i statusu',
    notes: 'Uwagi',
  },
  changes: {
    title: 'Dziennik zmian',
    description: 'Ostatnie zmiany rekordów ERP wykryte przez synchronizację (dane osobowe bez wartości).',
    empty: 'Brak zmian w dzienniku',
    kind: { NEW: 'Nowy', CHANGED: 'Zmieniony', REMOVED: 'Zniknął', RESTORED: 'Wrócił' },
    sensitive: 'zmieniono (dane osobowe — wartość nie jest zapisywana)',
  },
  outbox: {
    title: 'Kolejka do ERP',
    description: 'Zamówienia i kontrahenci czekający na zapis w Subiekcie GT przez usługę Sfera u klienta.',
    empty: 'Kolejka jest pusta',
    allKinds: 'Wszystkie rodzaje',
    allStatuses: 'Wszystkie statusy',
    kind: { ORDER: 'Zamówienie (ZK)', CUSTOMER: 'Kontrahent' },
    status: { PENDING: 'Oczekuje', CLAIMED: 'W realizacji', DONE: 'Zapisane w ERP', FAILED: 'Błąd' },
    col: { created: 'Utworzono', kind: 'Rodzaj', status: 'Status', attempts: 'Próby', erpNumber: 'Numer w ERP', source: 'Źródło', error: 'Ostatni błąd' },
    retry: 'Ponów',
    retried: 'Pozycja wróciła do kolejki',
    noProducer: 'NEXOPS nie ma jeszcze przyjmowania zamówień ani automatycznego zakładania kontrahentów — kolejka zapełni się, gdy powstaną te funkcje.',
  },
  tokens: {
    title: 'Tokeny integracji',
    description: 'Dostęp usługi Sfera u klienta do kolejki (nagłówek X-Integration-Token). Token widać tylko raz.',
    empty: 'Brak tokenów',
    name: 'Nazwa tokenu',
    namePlaceholder: 'np. Usługa Sfera — serwer biura',
    create: 'Utwórz token',
    created: 'Token utworzony',
    copyHint: 'Skopiuj go teraz — po zamknięciu nie będzie można go odczytać.',
    copy: 'Kopiuj',
    copied: 'Skopiowano',
    revoke: 'Odwołaj',
    revoked: 'Odwołany',
    confirmRevoke: 'Odwołać token „{name}”? Usługa przestanie mieć dostęp do kolejki.',
    col: { name: 'Nazwa', prefix: 'Początek', created: 'Utworzono', lastUsed: 'Ostatnio użyty', state: 'Stan' },
    active: 'Aktywny',
  },
};

type Shape<T> = { [K in keyof T]: T[K] extends string ? string : Shape<T[K]> };

export const erpsEn: Shape<typeof erpsPl> = {
  nav: { group: 'Integrations', log: 'Sync log', outbox: 'ERP outbox' },
  page: {
    title: 'Sync log',
    description: 'Continuous sync with the ERP (InsERT GT): feeds, schedule, runs, month reconciliation.',
    source: 'Source',
    lastSuccess: 'Last success',
    schedulerOn: 'Scheduler on',
    schedulerOff: 'Scheduler off',
    alarm: 'Sync is failing',
    schedulerOffHint: 'The scheduler is off on the server (ERP_SYNC_ENABLED). Manual runs and dry runs work if the server can reach the ERP database.',
    tabs: { feeds: 'Feeds', runs: 'Runs', changes: 'Change log' },
    never: 'never',
  },
  feed: {
    customers: 'Customers',
    products: 'Products',
    documents: 'Documents',
    receivables: 'Receivables',
    routimo: 'Routimo routes',
    reconcile: 'Month reconciliation',
    'ledger-costs': 'Ledger costs',
    collections: 'Debt collection',
    cashflow: 'Cash flow',
    purchasing: 'Purchasing and stock',
    quality: 'Quality — goods receipts',
    commissions: 'Sales commissions',
    consents: 'Customer consents',
    retro: 'Customer retro',
    warehouse: 'Warehouse — delivery notes',
    prices: 'Price lists and customer prices',
    leave: 'Employee leave',
  },
  feedHint: {
    customers: 'Customers, addresses, contacts, account managers',
    products: 'Product groups and products',
    documents: 'Invoices, corrections, receipts, orders, goods issues in a rolling {days}-day window',
    receivables: 'Open receivables and payments',
    routimo: 'Planned route stops (4:00–10:00)',
    reconcile: 'Document count and net per month, 24 months; differing months re-read',
    'ledger-costs': 'Rewizor: payroll by department, vehicle costs, production — last 3 months, nightly',
    collections: 'Payment demands, collection actions and e-mail reminders (new only)',
    cashflow: 'Cash registers, cash and bank documents, statements and payables ({days}-day window)',
    purchasing: 'Suppliers, purchase invoices, corrections, receipts and supplier orders in a rolling {days}-day window, stock levels',
    quality: 'Goods receipts (PZ) of 45 days — supplier of the goods for complaint analytics (3:15)',
    commissions: 'InsERT commission add-on: reps, rates, payouts (daily)',
    consents: 'E-invoice consent, marketing and e-mail consent (customer survey)',
    retro: 'Retro from the customer custom field "RETRO" in Subiekt (customer card, margin after retro - board only)',
    warehouse: 'Delivery notes to pick (lines, quantity, creation time) of the last days',
    prices: 'Product price levels, customer discounts and groups, individual prices and promotions of the add-on (full read every 20 h)',
    leave: 'From Gratyfikant: name, leave entitlement and carry-over, dates of annual leave (no sick leave or other absences)',
  },
  card: {
    status: {
      running: 'Running',
      alarm: 'ALARM',
      unavailable: 'Not available yet',
      off: 'Not scheduled',
      failed: 'Last run failed',
      ok: 'Working',
    },
    records: 'Tracked records',
    schedule: 'Schedule',
    every: 'every {minutes} min',
    daily: 'daily at {time}',
    hours: '{from}:00–{to}:00',
    lastSuccess: 'Last success',
    lastRun: 'Last run',
    alarmText: 'No successful sync for more than {minutes} min.',
    failing: 'Failing since {since}, consecutive failures: {count}.',
    lastError: 'Last error: {error}',
    unavailableHint: 'The mapping of this feed is not deployed in this server version yet.',
    dryRun: 'Dry run',
    run: 'Run now',
    confirmRun: 'Run the "{feed}" sync and WRITE the changes to NEXOPS?',
    enabled: 'Scheduled',
    enable: 'Add to schedule',
    disable: 'Remove from schedule',
  },
  toast: {
    done: '{feed}{dry}: new {created}, changed {changed}, removed {removed}',
    dry: ' (dry run)',
    running: '{feed}: still running — follow it in the run list',
    skipped: '{feed}: the previous run is still in progress — skipped',
    failed: '{feed}: {error}',
    unavailable: 'This feed is not available yet.',
    settingsSaved: 'Feed schedule saved',
  },
  runs: {
    title: 'Runs',
    description: 'Every feed run: scheduled, retries, manual and dry runs.',
    empty: 'No runs',
    allFeeds: 'All feeds',
    allStatuses: 'All statuses',
    col: {
      started: 'Started',
      feed: 'Feed',
      trigger: 'Trigger',
      status: 'Status',
      duration: 'Duration',
      fetched: 'Fetched',
      created: 'New',
      changed: 'Changed',
      unchanged: 'Unchanged',
      removed: 'Removed',
      restored: 'Restored',
      notes: 'Notes',
    },
    dryRun: 'dry run',
  },
  status: { RUNNING: 'Running', SUCCESS: 'Success', PARTIAL: 'Partial', FAILED: 'Failed', SKIPPED: 'Skipped' },
  trigger: { SCHEDULE: 'Schedule', MANUAL: 'Manual', CLI: 'Console', STARTUP: 'Server start', RETRY: 'Retry' },
  detail: {
    back: 'Sync log',
    title: 'Run: {feed}',
    window: 'Read window',
    by: 'Started by',
    finished: 'Finished',
    warnings: 'Warnings',
    error: 'Error',
    report: 'Report',
    noReport: 'The run saved no report.',
    notFound: 'Run not found.',
    preview: 'Change preview (dry run)',
    previewCounts: 'New: {created} · changed: {changed} · restored: {restored} · removed: {removed} · left the window: {agedOut}',
    rawReport: 'Full report (JSON)',
  },
  reconcile: {
    title: 'ERP reconciliation',
    summary: 'Period {from} – {to}: differences in {different} months, re-read {reread}, still different {still}.',
    col: { month: 'Month', type: 'Type', erpCount: 'ERP — count', nexopsCount: 'NEXOPS — count', erpNet: 'ERP — net', nexopsNet: 'NEXOPS — net', state: 'State' },
    equal: 'Equal',
    fixed: 'Fixed by re-read',
    differs: 'Different',
    onlyDiff: 'Differences only',
    statuses: 'Counted ERP document statuses: {statuses}',
    breakdown: 'ERP by type and status',
    notes: 'Notes',
  },
  changes: {
    title: 'Change log',
    description: 'Recent changes of ERP records detected by the sync (personal data without values).',
    empty: 'No changes in the log',
    kind: { NEW: 'New', CHANGED: 'Changed', REMOVED: 'Removed', RESTORED: 'Restored' },
    sensitive: 'changed (personal data — the value is not stored)',
  },
  outbox: {
    title: 'ERP outbox',
    description: 'Orders and customers waiting to be written to Subiekt GT by the Sfera service at the customer.',
    empty: 'The outbox is empty',
    allKinds: 'All kinds',
    allStatuses: 'All statuses',
    kind: { ORDER: 'Order (ZK)', CUSTOMER: 'Customer' },
    status: { PENDING: 'Pending', CLAIMED: 'In progress', DONE: 'Written to ERP', FAILED: 'Failed' },
    col: { created: 'Created', kind: 'Kind', status: 'Status', attempts: 'Attempts', erpNumber: 'ERP number', source: 'Source', error: 'Last error' },
    retry: 'Retry',
    retried: 'The item is back in the queue',
    noProducer: 'NEXOPS has no order taking or automatic customer creation yet — the outbox fills up once those features exist.',
  },
  tokens: {
    title: 'Integration tokens',
    description: 'Access of the Sfera service at the customer to the outbox (X-Integration-Token header). The token is shown once.',
    empty: 'No tokens',
    name: 'Token name',
    namePlaceholder: 'e.g. Sfera service — office server',
    create: 'Create token',
    created: 'Token created',
    copyHint: 'Copy it now — it cannot be read again after closing.',
    copy: 'Copy',
    copied: 'Copied',
    revoke: 'Revoke',
    revoked: 'Revoked',
    confirmRevoke: 'Revoke the token "{name}"? The service will lose access to the outbox.',
    col: { name: 'Name', prefix: 'Prefix', created: 'Created', lastUsed: 'Last used', state: 'State' },
    active: 'Active',
  },
};
